import React from "react";
import BuscarGuia from "../../../components/BuscarGuia";
import TableComponent from '../../../components/table/TableOps';
import { TableOp } from '../../../components/table/TableOps.tsx';
import { Button, CircularProgress, Snackbar, Slide } from "@material-ui/core";
import Http from '../../../Http';

export default class ImpresionMultiple extends TableComponent {

  componentDidMount() {
    let actions = [{ id: 'delete', icon: 'delete' }];
    const id = this.props.id_embarque || null;
    this.tableConfig(
      { dataUrl: `embarque-guia/${id}/filter`, deleteUrl: `embarque-guia/${id}/delete`, deleteField: 'g_folio', modUrl: '' },
      TableOp.Table('', [
        { label: 'Guia', id: 'g_folio' },
        { label: 'Estado', id: 'status' },
        { label: 'Cliente', id: 'cliente' },
        { label: 'Origen', id: 'origen_sucursal' },
        { label: 'Destino', id: 'destino_sucursal' },
      ], actions))
    // dejar ese espacio en blanco
    this.table(0, this.rpp, " ", this.orderBy);
  }

  dialogClose = async (op) => {
    this.setState({ dialog: { ...this.state.dialog, show: false } })
    if (op === 1) {
      const { tableData } = this.state;
      tableData.rows = tableData.rows.filter(row => row.id !== this.deleteRow.id)
      this.setState({ tableData: { ...tableData, rows: tableData.rows, total: tableData.rows.length, rpp: tableData.rows.length } })
    }
  }

  onAdddGuia = (guia) => {
    this.setState((state) => {
      if (state.tableData.rows.some((sguia) => sguia.id === guia.id)) {
        state.sbOpen = true;
        state.sbMsg = "La guia ya fue seleccionada";
      } else {
        state.tableData.rows.push({ ...guia });
        state.tableData.total = state.tableData.rows.length;
        state.tableData.rpp = state.tableData.rows.length;
        this.rpp = state.tableData.rows.length;
      }
      return state;
    });
  }

  onImprimir = async () => {
    this.setState({ loading: true });
    try {
      if (this.state.tableData.rows.length === 0) {
        this.setState({ sbMsg: 'No hay guias', sbOpen: true, loading: false });
        return;
      }
      let id_guias = this.state.tableData.rows.map(r => r.id);
      const Resp = await Http.post('guias-impresion', { id_guias, precios: false }, true, "arraybuffer");
        const blob = new Blob([Resp], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);
        const printWin = window.open(url, 'Etiqueta', 'width=1050,height=800');
        printWin.focus();
        printWin.print();
        URL.revokeObjectURL(url);
    } catch (error) {
      
    }
    this.setState({ loading: false });
  }

  render() {
    const { loading = false, sbOpen = false, sbMsg = '' } = this.state;
    return (
      <div>
        <BuscarGuia onSelect={this.onAdddGuia} condiciones={false} />
        <div style={{ display: 'flex', justifyContent: 'end' }} >
          <Button variant="contained" color="primary" type="submit" disabled={loading} onClick={this.onImprimir} >
            { loading &&
              <CircularProgress color="secondary" size={20} />
            } 
            Imprimir Todas las Guias
          </Button>
        </div>
        <this.TableRender />
        <Snackbar
            open={sbOpen}
            onClose={() => {
              this.setState({ sbOpen: false });
            }}
            TransitionComponent={Slide}
            message={<span>{sbMsg}</span>}
          />
      </div>
    );
  }
}
